module.exports = __webpack_public_path__ + "static/img/thumb-01.f5ec7e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/thumb/thumb-01.png
// module id = FAA3
// module chunks = 31